import React, { useState } from "react";
import { Button, Stack } from "@mui/material";
const buttonStyles = {
    minWidth: "120px",
    fontSize: "14px",
    fontWeight: "400",
    padding: "5px 16px",
    borderRadius: "8px",
    textTransform: "none"
};


export const AbsentBtn = ({ onClick }) => {
    return (
        <Button sx={{ ...buttonStyles, border: "1px solid #A90000", color: "#A90000" }}
         onClick={onClick}
         
         >
            Absent
        </Button>
    )
}

export const PresentBtn = ({ onClick }) => {
    return (
        <Button sx={{ ...buttonStyles, border: "1px solid #03A900", color: "#03A900" }} onClick={onClick}>
            Present
        </Button>
    )
}

const AttendanceButton = () => {
    const [showAbsent, setShowAbsent] = useState(false);
    const [showPresent, setShowPresent] = useState(true);

 
    const handlePresentClick = () => {
        setShowPresent(false);
        setShowAbsent(true);
    };

    const handleAbsentClick = () => {
        setShowPresent(true);
        setShowAbsent(false);
    };



    return (
        <Stack direction="column" my={"20px"} spacing={1}>
            {showPresent && (

                <PresentBtn onClick={handlePresentClick} />
            )}

            {showAbsent && (
                <AbsentBtn onClick={handleAbsentClick} />
            )}
        </Stack>
    );
};

export default AttendanceButton;